import { z } from 'zod'

const CoordSchema = z.object({
  x: z.number(),
  y: z.number(),
})

const GpsDeviceSchema = z.object({
  imei: z.string(),
  last_known_location: CoordSchema.nullable(),
  last_known_location_time: z.string().nullable(),
  last_known_external_voltage: z.number().nullable(),
  last_known_external_voltage_time: z.string().nullable(),
})

const BoatPhotoSchema = z.object({
  avatar: z.string(),
  thumbnail: z.string(),
  medium: z.string(),
})

export const BoatSchema = z.object({
  boat_id: z.number(),
  name: z.string(),
  boat_type_id: z.number().nullable(),
  length: z.number(),
  year_built: z.number(),
  boat_info_text: z.string(),
  gps_device: GpsDeviceSchema.nullable(),
  photos: BoatPhotoSchema.nullable(),
})

export const BoatsSchema = z.object({
  boats: z.array(BoatSchema),
})

export type Boat = z.infer<typeof BoatSchema>
export type Boats = z.infer<typeof BoatsSchema>
export type GpsDevice = z.infer<typeof GpsDeviceSchema>
export type BoatPhoto = z.infer<typeof BoatPhotoSchema>
export type Coord = z.infer<typeof CoordSchema>

// Location tracking types
const LocationSchema = z.object({
  gnss_utc_time: z.string(),
  sent_at: z.string().nullable(),
  created_at: z.string(),
  is_buffered: z.boolean(),
  speed: z.number().nullable(),
  azimuth: z.number().nullable(),
  altitude: z.number().nullable(),
  location: z.any(), // GeoJSON object
})

const BoatLocationsSchema = z.object({
  boat_id: z.number(),
  locations: z.array(LocationSchema),
})

export const BoatsLocationsResponseSchema = z.object({
  boats: z.array(BoatLocationsSchema),
})

export type Location = z.infer<typeof LocationSchema>
export type BoatLocations = z.infer<typeof BoatLocationsSchema>
export type BoatsLocationsResponse = z.infer<
  typeof BoatsLocationsResponseSchema
>

// Boat stops types
const BoatStopSchema = z.object({
  stop_id: z.number(),
  boat_id: z.number(),
  start_time: z.string(),
  end_time: z.string().nullable(),
  location: z.any(), // GeoJSON
  grid_location: z.any(),
})

export const BoatStopsResponseSchema = z.object({
  boat_id: z.number(),
  stops: z.array(BoatStopSchema),
})

export type BoatStop = z.infer<typeof BoatStopSchema>
export type BoatStopsResponse = z.infer<typeof BoatStopsResponseSchema>
